import { render, staticRenderFns } from "./stockout.vue?vue&type=template&id=ff2e00c0&scoped=true&"
import script from "./stockout.vue?vue&type=script&lang=js&"
export * from "./stockout.vue?vue&type=script&lang=js&"
import style0 from "./stockout.vue?vue&type=style&index=0&id=ff2e00c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2e00c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wwwroot\\dealer-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff2e00c0')) {
      api.createRecord('ff2e00c0', component.options)
    } else {
      api.reload('ff2e00c0', component.options)
    }
    module.hot.accept("./stockout.vue?vue&type=template&id=ff2e00c0&scoped=true&", function () {
      api.rerender('ff2e00c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/purchase/components/print/stockout.vue"
export default component.exports